<div class="app-layout">
  <app-header [mode]="isLandingRoute ? 'landing' : 'app'"></app-header>
  @if (!isLandingRoute) {
    <app-sidebar></app-sidebar>
  }
  <main class="main-content" [class.main-content-landing]="isLandingRoute">
    <router-outlet></router-outlet>
  </main>
</div>

<app-create-space-modal></app-create-space-modal>
<app-add-note-modal></app-add-note-modal>
<app-delete-space-modal></app-delete-space-modal>
<app-toast></app-toast>
